import Button from 'shared/components/form/button';
import './styles.scss';

interface ModalFooterProps {
	buttons: {
		text: string | JSX.Element;
		onClick?: () => void;
		btnType?: string;
		type?: string;
	}[];
}

export const ModalFooter = ({ buttons }: ModalFooterProps) => {
	const footerType = buttons.length > 1 ? 'multiple' : 'single';
	return (
		<div className={`modalFooter modalFooter--${footerType}`}>
			{buttons.map((button: any) => (
				<Button type={button.type} onClick={button.onClick} btnType={button.btnType}>
					{button.text}
				</Button>
			))}
		</div>
	);
};

export default ModalFooter;
